<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-input @change="selectHolidayRemainingPage" v-model="tableQuery.name" style="width: 200px;margin: 0 10px" placeholder="请输入名称"></el-input>
      <el-button :loading="tableLoading" type="danger" @click="selectHolidayRemainingPage">搜 索</el-button>
      <el-button type="danger" @click="batchUpdate()">批量修改</el-button>
    </div>
    <el-table
        :data="tableData" class="table" height="600px"
        row-key="id" border v-loading="tableLoading">
      <el-table-column prop="coachName" show-overflow-tooltip label="名称" width="120"/>
      <el-table-column prop="deptName" show-overflow-tooltip label="部门" width="160"/>
      <el-table-column show-overflow-tooltip label="入职时间" width="120" align="center">
        <template #default="scope">
          <el-popover :visible="visible"
              placement="top"
              :width="200"
              trigger="click">
            <div>
              <div style="font-weight: bold">编辑入职时间</div>
              <el-date-picker
                  v-model="scope.row.entryTime" value-format="yyyy-MM-dd"
                  type="date" style="width: 100%;margin: 20px 0"
                  placeholder="请选择" size="large"
                  @change="updateUserDate(scope.row)"
              />
            </div>
            <template #reference>
              <span style="color: #409EFF" v-if="scope.row.entryTime == ''">未设置</span>
              <span style="color: #409EFF" v-else>{{scope.row.entryTime}}</span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="首次工作时间" width="120" align="center">
        <template #default="scope">
          <el-popover :visible="visible"
                      placement="top"
                      :width="200"
                      trigger="click">
            <div>
              <div style="font-weight: bold">编辑首次工作时间</div>
              <el-date-picker
                  v-model="scope.row.firstWorkingTime" value-format="yyyy-MM-dd"
                  type="date" style="width: 100%;margin: 20px 0"
                  placeholder="请选择" size="large"
                  @change="updateUserDate(scope.row)"
              />
            </div>
            <template #reference>
              <span style="color: #409EFF" v-if="scope.row.firstWorkingTime == ''">未设置</span>
              <span style="color: #409EFF" v-else>{{scope.row.firstWorkingTime}}</span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column align="center" v-for="(item, index) in titleList" :key="index">
        <template #header>
          <div style="font-weight: bold;">{{ item }}</div>
        </template>
        <template #default="scope">
          <el-tooltip effect="dark" placement="top">
            <div slot="content">
              <div v-if="scope.row.holidayLibrary[index].limitBalance == 0">不限制余额</div>
              <div v-else>
                {{scope.row.holidayLibrary[index].holidayRulesName}}余额（{{scope.row.holidayLibrary[index].balance}}天）
              </div>
            </div>
            <div v-if="scope.row.holidayLibrary[index].limitBalance == 0">♾️</div>
            <div @click="thisUserHoliday(scope.row,index)" v-else style="color: #409EFF">
              {{scope.row.holidayLibrary[index].balance}}天
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        style="text-align: right;margin: 20px 10px"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="tableQuery.pageSize"
        @current-change="changePage"
        layout="total, prev, pager, next, jumper"
        :total="tableTotal">
    </el-pagination>
    <update-holiday-remaining @refresh="selectHolidayRemainingPage" ref="updateHolidayRemaining"/>
    <batch-update ref="batchUpdate"></batch-update>
  </div>
</template>

<script>
import {selectHolidayRemainingPage,updateUserInfo,exportHolidayRemaining} from "../../../../../api/attendance/holiday";

import UpdateHolidayRemaining from "./UpdateHolidayRemaining";
import BatchUpdate from "./BatchUpdate";
export default {
  name: "HolidayRemaining",
  components: {
    UpdateHolidayRemaining,BatchUpdate
  },
  data() {
    return {
      tableQuery:{
        name:"",
        pageIndex:0,
        pageSize:11,
      },
      visible:false,
      tableTotal:0,
      tableData:[],
      titleList:[],
      userHoliday:{},
      tableLoading:false,

    }
  },
  methods:{
    selectHolidayRemainingPage(){
      this.tableLoading = true;
      selectHolidayRemainingPage(this.tableQuery).then(val => {
        this.tableLoading = false;
        if (val.status==200){
          this.tableData = val.data.groupMap;
          this.titleList = val.data.head;
          this.tableTotal = val.data.total;
        }
      })
    },

    /**
     * 查看某个用户的假期详情
     */
    thisUserHoliday(item,index){
      item.index = index+'';
      this.$refs.updateHolidayRemaining.openDialog(JSON.parse(JSON.stringify(item)));
    },
    batchUpdate(){
      this.$refs.batchUpdate.openDialog();
    },
    updateUserDate(item){
      updateUserInfo(item).then(val=>{
        if (val.status==200){
          this.selectHolidayRemainingPage();
          this.$message({message: '更新成功！', type: 'success'});
        }else {
          this.$message.error('更新失败！');
        }
      })
    },
    changePage(index){
      this.tableQuery.pageIndex = index;
      this.selectHolidayRemainingPage();
    },
    /**
     * 导出
     */
    exportHolidayRemaining(){
      exportHolidayRemaining().then(val=>{
        if (val.status == 200){
          let url = val.data;
          window.URL = window.URL || window.webkitURL;
          var name = url.substring(url.lastIndexOf("/") + 1, url.length);
          var xhr = new XMLHttpRequest();
          var a = document.createElement("a");
          xhr.open("GET", url, true);
          xhr.responseType = "blob";
          xhr.onload = function() {
            var file = new Blob([xhr.response], { type: "application/octet-stream" });
            a.href = window.URL.createObjectURL(file);
            a.download = name;
            a.click();
          };
          xhr.send();
        }
      })
    }
  },
  created() {
    this.selectHolidayRemainingPage();
  }
}
</script>

<style scoped>
.table{
  width: 100%;
  border-radius: 10px;
  padding: 6px 0px 10px 6px;
}

</style>